import styled from 'styled-components'
import { isEmpty } from 'ramda'
import { noop } from 'lodash'
import { colors } from '@/styles'
import useProfile from '@/hooks/use-profile'
import { Avatar } from '@/components/avatar'
import { getImageUrl } from '@/utils/image'
import { RedCircleIcon } from '../icons'

const Nav = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  background-color: ${colors.grey96};
  border-radius: 64px;
  max-width: ${({ width }) => width || '109px'};
  min-width: 90px;
  height: 40px;
  padding: 4px 8px;
  cursor: pointer;
`

const NavText = styled.p`
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const AvatarWrapper = styled.div`
  position: relative;
  top: 0;
  left: 0;
`

const StyledRedCircleIcon = styled(RedCircleIcon)`
  position: absolute;
  left: 24px;
  z-index: 2;
`

const NavDropDown = ({ isOpen, setIsOpen, setReferenceElement, setAltOpen = noop, width }) => {
  const data = useProfile()
  const isTenant = data.user_type === 'tenant'

  const handleMouseDown = e => {
    e.stopPropagation()
  }

  const handleClick = e => {
    setIsOpen(!isOpen)
    setAltOpen(false)
  }

  const renderAvatar = () => (
    <AvatarWrapper>
      {isEmpty(data.avatar) && isTenant && <StyledRedCircleIcon />}
      <Avatar
        right={8}
        height={32}
        width={32}
        backgroundColor={colors.white}
        border={true}
        location={getImageUrl(data.avatar?.aws_s3_key, { width: 64, height: 64 })}
        alt={data.first_name}
        showIcon={true}
        absolute={false}
        relative={true}
      />
    </AvatarWrapper>
  )

  return (
    <Nav
      onClick={handleClick}
      onMouseDown={handleMouseDown}
      ref={setReferenceElement}
      width={width}
    >
      {renderAvatar()}
      <NavText>{data.first_name}</NavText>
    </Nav>
  )
}

export default NavDropDown
